import * as React from "react";
import ReactMarkdown from "react-markdown";

import { RLink } from "./RLink";
import { Paragraph } from "./formatting/Paragraph";

function processCommentText(text: string, maxLength?: number): string {
  // Replace mentions with links
  text = text.replace(/@([^\s^<]+)/g, (_match, username: string) => {
    if (username.toLowerCase() === "anonymous") {
      return `@${username}`;
    }

    return `[@${username}](/user/${username})`;
  });

  // truncate to max length if necessary
  // note order is important as to not cut off any thonks
  if (maxLength && text.length > maxLength) {
    text = text.slice(0, maxLength) + "...";
  }

  // Emoji support
  text = text.replace(/:thonk:/g, "![thonk](/img/thonk.png)");

  return text;
}

/**
 * FormattedText is a component that renders all user-input text on Chips -
 * comments, reviews, forum posts, entry descriptions, etc. The idea is to have
 * a single, unified way of rendering and styling text.
 */
export function FormattedText({
  text,
  maxLength,
}: {
  text: string;
  maxLength?: number;
}) {
  return (
    <div className="prose">
      <ReactMarkdown
        source={processCommentText(text, maxLength)}
        renderers={{
          link: RLink,
          paragraph: Paragraph,
        }}
      />
    </div>
  );
}
